import { pxToRem } from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';
import type { RGB } from '@modules/paint-picker/type';

export const Container: StyleRule<{
    rgb: RGB;
    show: boolean;
    desktop: boolean;
}> = ({ rgb, show, desktop }) => ({
    opacity: show ? 1 : 0,
    transition: `opacity 0.2s`,
    position: 'relative',
    width: desktop ? pxToRem(48) : pxToRem(77.56),
    height: desktop ? pxToRem(48) : pxToRem(77.56),
    backgroundColor: `rgb(${rgb.r}, ${rgb.g}, ${rgb.b})`,
    borderRadius: '50%',
    overflow: 'hidden',
    flexShrink: 0,
});

export const Colour: StyleRule<{
    frame: string;
}> = ({ frame }) => ({
    width: '100%',
    height: '100%',
    background: `url(${frame})`,
    backgroundSize: 'cover',
});
